"use client"

import Image from "next/image";

import { AnimatedSection } from "../animated-section";
import HeaderSection from "../header-section";
const AboutSection = () => {

  return ( 
    <AnimatedSection>
      <section id="sobre" className="py-10 md:py-20 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-18 items-center">
          <div className="relative">

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <Image
                  src="/close-up-veterinarian-taking-care-pet.jpg"
                  alt="Veterinário examinando cachorro"
                  className="rounded-lg object-cover w-full aspect-[4/5]"
                  width={600}
                  height={750}
                />
              </div>

              <div className="space-y-4 pt-8">
                <Image
                  src="/close-up-veterinary-doctor-taking-care-pet.jpg"
                  alt="Veterinário cuidando de pet"
                  className="rounded-lg object-cover w-full aspect-[4/5]"
                  width={600}
                  height={750}
                />
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <HeaderSection 
              title="Sobre nós"
              direction="left"
            />

            <div className="text-muted-foreground space-y-4">
              <p>
                A São Chico foi inaugurada em 8 de setembro de 2020, durante a pandemia, em um local que anteriormente abrigava um
                pet shop. A princípio, iniciou suas atividades como um consultório veterinário, mas, aproveitando a estrutura e o 
                histórico do espaço, foram incorporados os serviços de banho e tosa e uma pequena loja com venda de rações e acessórios.
              </p>
              <p>
                  Com o aumento da procura e a confiança dos clientes, surgiu a necessidade de ampliar a estrutura. 
                  Assim, o consultório foi elevado à categoria de clínica veterinária.
              </p>
              <p>
                Em pouco mais de um ano, devido ao crescimento constante da demanda, a São Chico mudou-se para um novo endereço, 
                localizado no centro da cidade, com um espaço três vezes maior do que o inicial — oferecendo mais conforto, 
                tecnologia e qualidade no atendimento aos pets e seus tutores.
              </p>
            </div>

           

{/* 
            <div className="grid grid-cols-2 gap-6 pt-4">
              <div>
                <p className="text-4xl font-bold text-primary mb-2">5.000+</p>
                <p className="text-muted-foreground">Pets atendidos</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-primary mb-2">98%</p>
                <p className="text-muted-foreground">Satisfação</p>
              </div>
            </div> */}

          </div>
        </div>
      </div>
    </section>
        {/* <section className="py-20 lg:py-24 bg-gradient-to-tl from-primary/5 to-white">
          <div className="container mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 md:gap-28 items-center">
              <motion.div
                className="relative"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
    
                <Image
                  src="/image-03.jpeg"
                  alt="Veterinária com cachorro"
                  className="w-full h-full object-cover rounded-4xl"
                  width={500}
                  height={600}
                  quality={65}
                  priority
                />
             
                <motion.div
                  className="absolute bottom-6 -right-3 md:-right-7"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                >
                   <motion.div
                    className="border-4 w-18 h-18 md:w-28 md:h-28 bg-emerald-100 text-emerald-500 border-white flex flex-col  gap-0 items-center justify-center text-center rounded-full"
                    animate={{ y: [0, -10, 0] }}
                    transition={{ duration: 3, repeat: Number.POSITIVE_INFINITY }}
                  >                
                     <PawPrint className="w-10 h-10 md:w-14 md:h-14 text-emerald-500" strokeWidth={1} />
                  </motion.div>
                </motion.div>
              </motion.div>


              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
               
           
                  { isLoading ? 
                    (
                      <SkeletonText lines={10} />
                    ) :  (
                      <div dangerouslySetInnerHTML={{ __html: about }} className="text-muted-foreground" />
                    )
                  }

                <div className="mt-10">
                  <Button asChild size="xl" className="group" aria-label="Sobre">
                    <Link href="/sobre" className="flex items-center gap-2">
                      Saiba mais
                      <ArrowRight className="h-5 w-5 ml-2 group-hover:ml-4 ease-in delay-150 transition-all" />
                    </Link>
                  </Button>
                </div>
              </motion.div>
            </div>
          </div>
        </section> */}
      </AnimatedSection>
   );
}
 
export default AboutSection;